<template>
  <div class="painel-wrap">
    <div class="painel-stage">
      <div v-for="(painel, index) in iterador.conteudo" :key="painel.id" class="painel-bloco" :class="{ 'mt-6': index > 0 }">
        <div class="painel-head">
          <v-icon color="white" class="mr-2">mdi-television-classic</v-icon>
          <span class="painel-nome">{{ painel.description }}</span>
          <span class="painel-live"><span class="painel-live__dot"></span>AO VIVO</span>
          <v-spacer></v-spacer>
          <span
            class="painel-count"
            :class="filtrarChamadores(painel.listaChamadores).length ? 'painel-count--ativo' : ''"
          >
            <v-icon x-small color="white" class="mr-1">mdi-bell-ring</v-icon>
            {{ filtrarChamadores(painel.listaChamadores).length }} chamando
          </span>
        </div>

        <div class="painel-grid">
          <div
            v-for="chamador in painel.listaChamadores"
            :key="chamador.id + '-' + x"
            class="leito"
            :class="{ 'leito--ativo': chamador.estado }"
            :style="{ background: chamador.estado ? '#e53935' : painel.bgPainelColor }"
            :id="chamador.descricao + chamador.numero"
            @click="chamador.estado && (chamador.tipo == 'CHAMADOR' || chamador.tipo == 'BANHEIRO') ? pegaInformacoes(chamador.id) : ''"
          >
            <div class="leito__info">
              <span class="leito__desc" :style="{ color: chamador.estado ? '#fff' : painel.textLeitoColor }">{{ chamador.descricao }}</span>
              <span class="leito__num" :style="{ color: chamador.estado ? '#fff' : painel.textLeitoColor }">{{ chamador.numero }}</span>
            </div>
            <div class="leito__icon">
              <v-progress-circular :rotate="360" :size="100" :width="12" :value="((chamador.ultimoPeso * 100) / 0.550)" color="white" v-if="chamador.tipo == 'SORO'">
                {{ ((chamador.ultimoPeso / 1.006) * 1000).toFixed(1) }}<br>ml
              </v-progress-circular>
              <v-icon v-if="chamador.tipo == 'BANHEIRO'" color="white" size="54">mdi-toilet</v-icon>
              <v-icon v-if="chamador.tipo == 'CHAMADOR' && chamador.estado" color="white" size="54">mdi-bell-ring</v-icon>
              <v-icon v-if="chamador.tipo == 'CHAMADOR' && !chamador.estado" color="white" size="54">mdi-bell</v-icon>
            </div>
          </div>
        </div>

        <div v-if="filtrarChamadores(painel.listaChamadores).length == 0" class="painel-tranquilo">
          <v-icon color="#5ec4c4" size="40">mdi-check-circle-outline</v-icon>
          <span>Tudo tranquilo — nenhum chamado no momento</span>
        </div>
      </div>
    </div>

    <v-dialog v-model="dialogoInformaPin" max-width="320px" class="ai-dialog">
      <v-card>
        <v-card-title><v-icon>mdi-lock</v-icon>Informe seu PIN</v-card-title>
        <v-card-text class="ai-dialog-body">
          <v-text-field outlined dense hide-details type="password" autofocus label="PIN" v-model="desativarChamado.pin" @keyup.enter="desativaChamado"></v-text-field>
        </v-card-text>
        <v-card-actions class="px-5 pb-4">
          <v-btn block color="primary" depressed @click="desativaChamado">
            <v-icon left>mdi-bell-check</v-icon>Desativar chamado
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
	import { baseApiUrl } from '@/global'
	import Snackbar from '../componentes/snackbar.vue'
	import axios from 'axios'
	import { mapState } from 'vuex'

	export default {
		components: { Snackbar, },

		data() {
			return {
				iterador: {
					carregamento: false,
          categorias: [],
          conteudo: [],
          itensPorPagina: -1
        },
        dialogoInformaPin: false,
        desativarChamado: {
          chamadorId: '',
          pin: '',
        },
        x: 0,
        intervaloVerificacao: null,
			}
		},

		computed: mapState({
			usuarioLogado: state => state.isMenuVisible,
			user: state => state.userObj,
			companyobj: state => state.companyObj,
		}),

    watch: {
      dialogoInformaPin(val) {
        if (val == false) {
          setTimeout(() => {
            this.desativarChamado.chamadorId = ''
            this.desativarChamado.pin = ''
          }, 300);
        }
      },
    },

		async mounted() {
			await this.carregaPaineis(true)
      this.intervaloVerificacao = setInterval(() => {
        this.verificaPaineis()
      }, 5000);
		},

    beforeDestroy() {
      clearInterval(this.intervaloVerificacao)
    },

		methods: {
			async carregaPaineis() {
        this.iterador.conteudo = []
				for (let i = 0; i < this.user.paineis.length; i++) {
					let painel
					await axios.get(baseApiUrl + 'Paineis/' + this.user.paineis[i])
					.then(async response => {
						if (response.data) {
              painel = response.data

							await axios.post(baseApiUrl + 'Paineis/chamadores', {"mac": response.data.macAddress})
              .then(result => {
                if (result.data) {
                  painel.listaChamadores = []

                  for (let i = 0; i < result.data.listaChamadores.length; i++) {
                    if (result.data.listaChamadores[i].estado) {
                      painel.listaChamadores.push(result.data.listaChamadores[i])
                    }
                  }
                }
              })

							this.iterador.conteudo.push(painel)
						}
					})
				}
			},

      async verificaPaineis() {
				for (let i = 0; i < this.user.paineis.length; i++) {
					let painel
					await axios.get(baseApiUrl + 'Paineis/' + this.user.paineis[i])
					.then(async response => {
						if (response.data) {
              painel = response.data

							await axios.post(baseApiUrl + 'Paineis/chamadores', {"mac": response.data.macAddress})
              .then(result => {
                if (result.data) {
                  painel.listaChamadores = []

                  for (let i = 0; i < result.data.listaChamadores.length; i++) {
                    if (result.data.listaChamadores[i].estado) {
                      painel.listaChamadores.push(result.data.listaChamadores[i])
                    }
                  }
                }
              })

              let indice = this.iterador.conteudo.findIndex(function(painelFind) {
                return painelFind.id === painel.id;
              });

              this.iterador.conteudo[indice] = Object.assign({}, painel)
              this.x++
						}
					})
				}
			},

      pegaInformacoes(idChamador) {
        this.desativarChamado.chamadorId = idChamador
        this.dialogoInformaPin = true
      },

      async desativaChamado() {
        var vm = this;
        await axios.post(baseApiUrl + 'Chamadores/finalizarChamado', this.desativarChamado)
        .then(response => {
          if (response.data) {
            this.notificaPainel()
            this.carregaPaineis()
            this.dialogoInformaPin = false
            vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso", "SUCESSO")
          }
        })
        .catch(error => {
          if (error.response.data.error.message.includes('Usuário não encontrado.')) {
            vm.$refs.chamaSnackbar.snack("orange", error.response.data.error.message, "ATENÇÃO")
          } else {
            vm.$refs.chamaSnackbar.snack("red", "Problema ao realizar operação", "DESCULPE")
          }
        })
      },

      async notificaPainel() {
        await axios.post(baseApiUrl + 'Paineis/notificaPainel?access_token=' + sessionStorage.getItem("accToken"), {"empresaId": this.companyobj.id})
      },

      filtrarChamadores(lista) {
        return lista.filter(chamador => chamador.estado === true)
      }
		},
	}
</script>

<style scoped>
.painel-wrap {
  min-height: 100vh;
  width: 100%;
  background: radial-gradient(1200px 600px at 50% -10%, #1a1b57 0%, #0f0f41 55%, #0a0a2e 100%);
  padding: 24px 20px 40px;
}
.painel-stage {
  max-width: 1500px;
  margin: 0 auto;
}
.painel-bloco {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  padding: 18px;
}
.painel-head {
  display: flex;
  align-items: center;
  padding: 4px 8px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  margin-bottom: 16px;
}
.painel-nome {
  color: #fff;
  font-size: 1.4rem;
  font-weight: 800;
  letter-spacing: 0.5px;
}
.painel-live {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: 14px;
  color: #5ec4c4;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
}
.painel-live__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2ee6a6;
  box-shadow: 0 0 0 0 rgba(46, 230, 166, 0.7);
  animation: pulseDot 1.8s infinite;
}
@keyframes pulseDot {
  0% { box-shadow: 0 0 0 0 rgba(46, 230, 166, 0.6); }
  70% { box-shadow: 0 0 0 8px rgba(46, 230, 166, 0); }
  100% { box-shadow: 0 0 0 0 rgba(46, 230, 166, 0); }
}
.painel-count {
  display: inline-flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.82rem;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.08);
  padding: 5px 12px;
  border-radius: 999px;
}
.painel-count--ativo {
  background: #e53935;
  color: #fff;
}

.painel-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
}
.leito {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 16px;
  overflow: hidden;
  min-height: 132px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.25);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.leito--ativo {
  cursor: pointer;
  animation: leitoPulse 1.2s ease-in-out infinite;
}
.leito--ativo:hover {
  transform: translateY(-2px);
}
@keyframes leitoPulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(229, 57, 53, 0.55); }
  50% { box-shadow: 0 0 0 10px rgba(229, 57, 53, 0); }
}
.leito__info {
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  text-align: left;
}
.leito__desc {
  font-size: 0.95rem;
  font-weight: 600;
  opacity: 0.95;
}
.leito__num {
  font-size: 2.6rem;
  font-weight: 800;
  line-height: 1.1;
}
.leito__icon {
  width: 120px;
  min-height: 132px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.12);
}
.painel-tranquilo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 28px;
  color: rgba(255, 255, 255, 0.75);
  font-size: 1rem;
}
</style>
